import { CustomButton } from '../../../../../components/CustomButton';
import { Spacer } from '../../../../../components/Spacer';

export function Footer({
  idGrupo,
  onDelete,
  active,
  handleBack,
  isPizzaGroup,
  handleConfirm,
  isLoading,
  grupo,
  close,
  onOpenMountings,
}) {
  return (
    <>
      {Boolean(idGrupo) && (
        <CustomButton onClick={onDelete} appearance="subtle">
          Apagar grupo
        </CustomButton>
      )}

      {Boolean(idGrupo) && (
        <CustomButton onClick={onOpenMountings} appearance="subtle">
          Montagem em Lote
        </CustomButton>
      )}

      <Spacer flex={1} />

      {!idGrupo && active !== 'tipo' && (
        <CustomButton onClick={handleBack} appearance="ghost">
          Voltar
        </CustomButton>
      )}
      <CustomButton
        onClick={handleConfirm}
        appearance="primary"
        disabled={isLoading}
      >
        {active === 'bordas' ||
        (!isPizzaGroup && active === 'tamanhos') ||
        grupo?.Id
          ? 'Salvar'
          : 'Continuar'}
      </CustomButton>
      <CustomButton onClick={close} appearance="default">
        Fechar
      </CustomButton>
    </>
  );
}
